export default __webpack_public_path__ + "static/media/Docker.c835660e.svg";